<template lang="pug">
  tr
      td(v-if="workflow.leaveUser && workflow.leaveUser.length > 0" class="table-cell")
          div(v-if="workflow.status == 7" class="approved")
              br
              | {{ workflow.leaveUser[0].name }}
              br
          div(v-else-if="workflow.status == 8" class="approved")
              br
              | {{ workflow.admin_reject ? workflow.admin_detail.name : workflow.leaveUser[0].name }}
              br
          div(v-else class="emptySign")
      td(v-if="workflow.leaveUser && workflow.leaveUser.length > 0" class="table-cell")
          div(v-if="workflow.status == 7" class="approved")
              br
              | {{ workflow.leaveUser[0].title }}
              br
          div(v-else-if="workflow.status == 8" class="approved")
              br
              | {{ workflow.admin_reject ? 'Admin' : workflow.leaveUser[0].title }}
              br
          div(v-else class="emptySign") {{ computedJabatanDetail }}
      td(v-if="!workflow.leaveUser || workflow.leaveUser.length === 0" class="table-cell")
          div(v-if="workflow.status == 7" class="approved")
              br
              | {{ displayName }}
              br
          div(v-else-if="workflow.status == 8" class="approved")
              br
              | {{ workflow.admin_reject ? workflow.admin_detail.name : displayName }}
              br
          div(v-else class="emptySign")
      td(v-if="!workflow.leaveUser || workflow.leaveUser.length === 0" class="table-cell")
          div(v-if="workflow.status == 7" class="approved")
              br
              | {{ displayTitle }}
              br
          div(v-else-if="workflow.status == 8" class="approved")
              br
              | {{ workflow.admin_reject ? 'Admin' : displayTitle }}
              br
          div(v-else class="emptySign") {{ computedJabatanDetail }}
      td(class="table-cell")
          div(v-if="workflow.status == 7" class="approved")
              br
              | {{ formattedDate }}
              br
          div(v-else-if="workflow.status == 8" class="approved")
              br
              | {{ formattedDate }}
              br
          div(v-else class="emptySign")
      td(class="table-cell" style="position: relative;")
          div(v-if="workflow.status == 7" class="approved")
              img(src="../assets/check-64.png" style="width:25px;")
          div(v-else-if="workflow.status == 8" class="approved")
              img(src="../assets/close-64.png" style="width:25px;")
          div(v-else class="emptySign")
          
          div(v-if="!showFor && workflow.leaveUser && workflow.leaveUser.length > 0" class="custom__position-for") for 
          div(v-if="showFor && isKTTSubstitute(workflow)" class="custom__position-for") for 

      td(class="table-cell")
          p(v-if="workflow.comment" class="align-left top-align comment") {{ workflow.comment }}
          div(v-else class="emptySign")
</template>

<script>
import helper from '@/helper/index.js'

export default {
  name: 'WorkflowDisplay',
  props: {
    workflow: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    formType: {
      type: String,
      required: true
    },
    showFor: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedDate() {
      return this.workflow.date ? new Date(this.workflow.date).toLocaleString('en-GB') : '';
    },
    computedJabatanDetail() {
      return helper.jabatanDetail(this.workflow.postAs, this.index, this.formType);
    },
    displayName() {
      return helper.getKTTApproverName(this.workflow);
    },
    displayTitle() {
      return helper.getKTTApproverTitle(this.workflow);
    }
  },
  methods: {
    isKTTSubstitute(item) {
      return helper.isKTTSubstitute(item)
    }
  }
}
</script>

<style scoped>
.approved {
  text-align: center;
  padding: 5px;
}
.emptySign {
  text-align: center;
  padding: 5px;
}
.align-left {
  align-items: left;
}
.top-align {
  vertical-align: top;
}
.comment {
  word-break: break-all;
}
.custom__position-for {
  font-size: 8px; 
  font-style: italic; 
  position: absolute; 
  bottom: 0; 
  left: 0;
}
.table-cell {
  border: 1px solid black;
  padding-left: 5px;
}
</style>